import * as React from 'react';
import styled from 'styled-components';
import IViewProps from '../../IViewProps';
import CreditDisplay from '../CreditDisplay';

import CardWithHeader from '../CardWithHeader';
import RewardPurchaseListItem from './RewardPurchaseListItem';
import InfoMessage from '../InfoMessage';
import Menu from '../Menu';

export const List = styled.ul`
display: flex;
flex-direction: column;
justify-content: center;
margin: 0;
padding: 0;
overflow: hidden;
list-style-type: none;
`;

export default function RewardPurchaseList(props: IViewProps) {
  const menuOrTitle = props.isAuthenticated
  ? <>
      <Menu
          appMode={props.appMode}
          showRewardCategoryList={props.onShowRewardCategoryList}
        showPurchaseHistory={props.onShowPurchaseHistory}
      ></Menu>
      <CreditDisplay label="" amount={props.credits!}/>
    </>
  : 'Bestellübersicht';
  return (
  <CardWithHeader
    title={menuOrTitle}
    className={'inverted'}
    onGoBack={props.onGoBack}
  >
    { (!props.rewards || !props.rewards.length ||
      !props.rewardCategories || !props.rewardCategories.length ||
      !props.rewardPurchases || !props.rewardPurchases.length) && (
      <InfoMessage>Du hast noch keine Bestellungen.</InfoMessage>
  )}
    <List>
      {
        props.rewardPurchases.map(rewardPurchase => (
          <RewardPurchaseListItem
            key={rewardPurchase.id}
            rewardPurchase={rewardPurchase}
            rewards={props.rewards!}
            rewardCategories={props.rewardCategories!}
          ></RewardPurchaseListItem>
        ))
      }
    </List>
  </CardWithHeader>
  );

}



// WEBPACK FOOTER //
// ./src/components/RewardPurchaseList/RewardPurchaseList.tsx